import { FC } from "react";
import { NotificationDTO } from "../../../domain/models/dto/NotificationDTO";
import PaginatedList from "../../resources/components/PaginatedList";
import { CollectionResponse } from "../../../types/ApiResults";
import ApplicationNewCard from "./notification-cards/ApplicationNewCard";
import ApplicationApprovedCard from "./notification-cards/ApplicationApprovedCard";
import ApplicationDeclinedCard from "./notification-cards/ApplicationDeclinedCard";
import SubscriptionActivatedCard from "./notification-cards/SubscriptionActivatedCard";
import SubscriptionReferralCard from "./notification-cards/SubscriptionReferralCard";
import SubscriptionTransactionFailedCard from "./notification-cards/SubscriptionTransactionFailedCard";
import ReviewCreateCard from "./notification-cards/ReviewCreateCard";
import ReviewReceivedCard from "./notification-cards/ReviewReceivedCard";
import { NotificationType } from "../../../domain/enums/NotificationTypeEnum";
import { useNavigate } from "react-router-dom";
import { NotificationServiceImpl } from "../../../services/NotificationServiceImpl";
import { useAppDispatch } from "../../../custom-hooks/useAppDispatch";
import _ from "lodash";

interface NotificationListProps {
    uploadNotificationsCallback: () => Promise<void>;
    notifications: CollectionResponse<NotificationDTO>;
}

const NotificationList: FC<NotificationListProps> = (props) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const getNotificationElement = (notification: NotificationDTO) => {
        const getOnClickCallback = (redirectedUrl: string) => {
            return () => {
                navigate(redirectedUrl);
                dispatch(NotificationServiceImpl.markAsReadNotificationThunk(notification));
            };
        };

        switch (notification.type) {
            case NotificationType.APPLICATION_NEW:
                return (
                    <ApplicationNewCard
                        key={notification.id}
                        notification={notification}
                        onClick={getOnClickCallback(`/work/${_.get(notification, "application.work.id")}`)}
                    />
                );
            case NotificationType.APPLICATION_APPROVED:
                return (
                    <ApplicationApprovedCard
                        key={notification.id}
                        notification={notification}
                        onClick={getOnClickCallback(`/work/${_.get(notification, "application.work.id")}`)}
                    />
                );
            case NotificationType.APPLICATION_DECLINED:
                return (
                    <ApplicationDeclinedCard
                        key={notification.id}
                        notification={notification}
                        onClick={getOnClickCallback(`/work/${_.get(notification, "application.work.id")}`)}
                    />
                );
            case NotificationType.SUBSCRIPTION_ACTIVATED:
                return (
                    <SubscriptionActivatedCard
                        key={notification.id}
                        notification={notification}
                        onClick={getOnClickCallback("/subscription")}
                    />
                );
            case NotificationType.SUBSCRIPTION_REFERRAL:
                return (
                    <SubscriptionReferralCard
                        key={notification.id}
                        notification={notification}
                        onClick={getOnClickCallback("/subscription")}
                    />
                );
            case NotificationType.SUBSCRIPTION_TRANSACTION_FAILED:
                return (
                    <SubscriptionTransactionFailedCard
                        key={notification.id}
                        notification={notification}
                        onClick={getOnClickCallback("/subscription")}
                    />
                );
            case NotificationType.EMPLOYEE_REVIEW_CREATE:
                return <ReviewCreateCard key={notification.id} notification={notification} />;
            case NotificationType.CLIENT_REVIEW_CREATE:
                return <ReviewCreateCard key={notification.id} notification={notification} />;
            case NotificationType.REVIEW_RECEIVED:
                return <ReviewReceivedCard key={notification.id} notification={notification} />;
            default:
                return <></>;
        }
    };

    return (
        <div className="flex flex-col gap-4 dmax2:gap-3">
            <PaginatedList
                entities={props.notifications}
                uploadCallback={props.uploadNotificationsCallback}
                getItemElement={getNotificationElement}
            />
        </div>
    );
};

export default NotificationList;
